import { GET_USER_BY_DEP_OK, GET_USER_BY_DEP_ERR } from "./user.action";

const InitState = {
  error: null,
  content: null,
};

export default function UserReducer(state = InitState, action) {
  switch (action.type) {
    case GET_USER_BY_DEP_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_USER_BY_DEP_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
